module.exports = __webpack_public_path__ + "img/logo.ef4f93cc.png";